import * as React from 'react';
export default function useCheckable(cascaderPrefixCls, multiple) {
    return React.useMemo(() => (multiple ? React.createElement("span", { className: `${cascaderPrefixCls}-checkbox-inner` }) : false), [multiple]);
}
